import {
    mapGetters,
} from 'vuex';

import {
    hasImageMimeType,
    hasVideoMimeType,
    hasAudioMimeType,
    hasApplicationMimeType,
} from '@shared/modules/fan-engagement/constants/mimeType';

export const mimeTypeMixin = {
    computed: {
        ...mapGetters('serverConfig', ['serverConfigByKey']),
        ...mapGetters('remoteConfig', ['remoteConfigByKey']),

        MIME_TYPES() {
            return this.serverConfigByKey('mimeTypes') ||
                this.remoteConfigByKey('mimeTypes') ||
                {};
        },
    },
    methods: {
        hasImageMimeType(assetMimeType) {
            return hasImageMimeType(this.MIME_TYPES.IMAGE)(assetMimeType);
        },

        hasVideoMimeType(assetMimeType) {
            return hasVideoMimeType(this.MIME_TYPES.VIDEO)(assetMimeType);
        },

        hasAudioMimeType(assetMimeType) {
            return hasAudioMimeType(this.MIME_TYPES.AUDIO)(assetMimeType);
        },

        hasApplicationMimeType(assetMimeType) {
            return hasApplicationMimeType(this.MIME_TYPES.APPLICATION)(assetMimeType);
        },
    },
};